import { useContext } from "react";
import { SscIamContext } from "./SscIamContext";

export const useSscIam = () => {
  const context = useContext(SscIamContext);

  if (!context) {
    throw new Error(
      "useSscIam must be used within a SscIamProvider. Wrap a parent component in <SscIamProvider> to fix this error."
    );
  }

  return { ...context };
};
